import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, TemplateRef} from '@angular/core'
import {ContentHeaderService} from '../../../../services/content-header.service'
import {CoreModule} from "../../../core.module";

@Component({
    selector: 'app-content-header',
    templateUrl: './content-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CoreModule],
    standalone: true
})
export class ContentHeaderComponent implements OnInit {
  public contentRef: TemplateRef<string> | null = null

  public ngOnInit () {
    this.contentHeaderService.$content.subscribe({
      next: value => {
        this.contentRef = null
        if (value != null) {
          this.contentRef = value
        }
        this.cdr.markForCheck()
      }
    })
  }

  public constructor (
    private readonly cdr: ChangeDetectorRef,
    private readonly contentHeaderService: ContentHeaderService
  ) {}
}
